import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {getUserTemplatesWithCaching} from "~/utilities/queries";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/user-templates")({
    loader: async ({context}) => {
        const userTemplatesResult = await getUserTemplatesWithCaching({
            workspaceId: context.workspace.id,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
            queryClient: context.queryClient,
        });

        if (userTemplatesResult.success !== true) {
            throw new Error("Failed to fetch user templates");
        }

        const userTemplates = userTemplatesResult.data;

        return {
            userTemplates: userTemplates,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
